import type { BrandSpecials } from '@iheartjane/data-access';
import { getApplicableGoldTagLabel } from '@iheartjane/menu';
import type { PriceId } from '@iheartjane/types';

interface GetGoldLabelArgs {
  applicableBrandSpecialIds: number[];
  brandSpecials: BrandSpecials;
  lowestAvailablePriceVal?: string | null;
}

export function getGoldLabel({
  applicableBrandSpecialIds,
  brandSpecials,
  lowestAvailablePriceVal,
}: GetGoldLabelArgs): string | null {
  if (!applicableBrandSpecialIds.length || !brandSpecials.length) return null;

  return getApplicableGoldTagLabel({
    applicableBrandSpecialIds,
    brandSpecials,
    priceId: lowestAvailablePriceVal?.split('price_')[1] as PriceId | undefined,
  });
}
